import BaseApi from './baseApi';
import IInboundDeliveryNotesDetail from '../models/IInboundDeliveryNotesDetail';
import IAuthentication from '../models/IAuthentication';
export default class InboundDeliveryNotesDetailApi extends BaseApi {
    idUser : string = "";
    constructor() {
        super("dataaccess", "Inbounds");
        let userFromStorage : IAuthentication = JSON.parse(sessionStorage.getItem('user') || '{}');
        this.idUser = userFromStorage.idPerson;
    }

    async GetInboundDeliveryNotesDetailById(id: string) : Promise<IInboundDeliveryNotesDetail[]> {
        let json : string = this.getJsonReadById(id);
        const response = await this.api.post('read', json);
        if (!response) return [];
        if (response.isSuccess) {
            var inboundDeliveryNotesDetails: IInboundDeliveryNotesDetail[] = [];
            inboundDeliveryNotesDetails = response.data as IInboundDeliveryNotesDetail[];
            return inboundDeliveryNotesDetails;
        } else {
            this.modelState = response.errorState;
            return [];
        }
    }

    async GetInboundDeliveryNotesDetailByIdInboundDeliveryNote(idInboundDeliveryNote: string) : Promise<IInboundDeliveryNotesDetail[]> {
        let json : string = this.getJsonReadByIdInboundDeliveryNote(idInboundDeliveryNote);
        const response = await this.api.post('read', json);
        if (!response) return [];
        if (response.isSuccess) {
            var inboundDeliveryNotesDetails: IInboundDeliveryNotesDetail[] = [];
            inboundDeliveryNotesDetails = response.data as IInboundDeliveryNotesDetail[];
            return inboundDeliveryNotesDetails;
        } else {
            this.modelState = response.errorState;
            return [];
        }
    }

    async SaveInboundDeliveryNotesDetail(inboundDeliveryNotesDetail: IInboundDeliveryNotesDetail) : Promise<string> {
        const json = this.getJsonSave(inboundDeliveryNotesDetail);
        const response = await this.api.post('save', json);
        if (!response) return "";
        if (response.isSuccess) {
            return response.data as string;
        } else {
            this.modelState = response.errorState;
        }

        return "";
    }

    async UpdateInboundDeliveryNotesDetail(inboundDeliveryNotesDetail: IInboundDeliveryNotesDetail) : Promise<boolean> {
        const json = this.getJsonUpdate(inboundDeliveryNotesDetail);
        const response = await this.api.post('save', json);
        return this.isSuccess(response);
    }

    async DeleteInboundDeliveryNotesDetail(id: string) : Promise<boolean> {
        const json = this.getJsonDelete(id);
        const response = await this.api.post('delete', json);
        return this.isSuccess(response);
    }

    async DeleteInboundDeliveryNotesDetailByInboundDetailId(inboundDetailId: string) : Promise<boolean> {
        const json = this.getJsonDeleteByInboundDetailId(inboundDetailId);
        const response = await this.api.post('delete', json);
        return this.isSuccess(response);
    }

    async DeleteInboundDeliveryNotesDetailByInboundDeliveryNoteId(inboundDeliveryNoteId: string) : Promise<boolean> {
        const json = this.getJsonDeleteByInboundDeliveryNoteId(inboundDeliveryNoteId);
        const response = await this.api.post('delete', json);
        return this.isSuccess(response);
    }

    async DeleteInboundDeliveryNotesDetailByInboundId(inboundId: string) : Promise<boolean> {
        const json = this.getJsonDeleteByInboundId(inboundId);
        const response = await this.api.post('delete', json);
        return this.isSuccess(response);
    }

    private getJsonDeleteByInboundId(inboundId: string) : any {
        const json = {
            "deleteMetadata": [{
                "Item1": "DeletedBy",
                "Item2": this.idUser
            }, {
                "Item1": "DeletedDate",
                "Item2": new Date()
            }],
            "table": "InboundsDeliveryNotesDetail",
            "conditions": [{
                "Item1": "InboundsDeliveryNotesDetail",
                "Item2": "IdInboundDeliveryNote",
                "Item3": "IN",
                "Item4": "(SELECT Id FROM InboundsDeliveryNotes WHERE IdInbound = '" + inboundId + "')"
            }]
        };
        return json;
    }

    private getJsonDeleteByInboundDetailId(inboundDetailId: string) : any {
        const json = {
            "deleteMetadata": [{
                "Item1": "DeletedBy",
                "Item2": this.idUser
            }, {
                "Item1": "DeletedDate",
                "Item2": new Date()
            }],
            "table": "InboundsDeliveryNotesDetail",
            "conditions": [{
                "Item1": "InboundsDeliveryNotesDetail",
                "Item2": "idInboundDetail",
                "Item3": "=",
                "Item4": inboundDetailId
            }]
        };
        return json;
    }

    private getJsonDeleteByInboundDeliveryNoteId(inboundDeliveryNoteId: string) : any {
        const json = {
            "deleteMetadata": [{
                "Item1": "DeletedBy",
                "Item2": this.idUser
            }, {
                "Item1": "DeletedDate",
                "Item2": new Date()
            }],
            "table": "InboundsDeliveryNotesDetail",
            "conditions": [{
                "Item1": "InboundsDeliveryNotesDetail",
                "Item2": "idInboundDeliveryNote",
                "Item3": "=",
                "Item4": inboundDeliveryNoteId
            }]
        };
        return json;
    }

    private getJsonDelete(id: string) : any {
        const json = {
            "deleteMetadata": [{
                "Item1": "DeletedBy",
                "Item2": this.idUser
            }, {
                "Item1": "DeletedDate",
                "Item2": new Date()
            }],
            "table": "InboundsDeliveryNotesDetail",
            "conditions": [{
                "Item1": "InboundsDeliveryNotesDetail",
                "Item2": "id",
                "Item3": "=",
                "Item4": id
            }]
        };
        return json;
    }

    private getJsonSave(inboundDeliveryNotesDetail: IInboundDeliveryNotesDetail) : any {
        const json = {
            "fieldsvalues": [{
                "Item1": "idInboundDeliveryNote",
                "Item2": inboundDeliveryNotesDetail.idInboundDeliveryNote
            }, {
                "Item1": "idInboundDetail",
                "Item2": inboundDeliveryNotesDetail.idInboundDetail
            }, {
                "Item1": "idGood",
                "Item2": inboundDeliveryNotesDetail.idGood
            }, {
                "Item1": "idListPallet",
                "Item2": inboundDeliveryNotesDetail.idListPallet
            }, {
                "Item1": "palletsAmount",
                "Item2": inboundDeliveryNotesDetail.palletsAmount
            }, {
                "Item1": "casesPerPallet",
                "Item2": inboundDeliveryNotesDetail.casesPerPallet
            }, {
                "Item1": "totalCases",
                "Item2": inboundDeliveryNotesDetail.totalCases
            }, {
                "Item1": "goodsPerCase",
                "Item2": inboundDeliveryNotesDetail.goodsPerCase
            }, {
                "Item1": "totalGoods",
                "Item2": inboundDeliveryNotesDetail.totalGoods
            }, {
                "Item1": "Location",
                "Item2": inboundDeliveryNotesDetail.location
            }, {
                "Item1": "weight",
                "Item2": inboundDeliveryNotesDetail.weight
            }, {
                "Item1": "bestBeforeDate",
                "Item2": inboundDeliveryNotesDetail.bestBeforeDate
            }, {
                "Item1": "Deleted",
                "Item2": 0
            }, {
                "Item1": "CreatedBy",
                "Item2": this.idUser
            }, {
                "Item1": "CreatedDate",
                "Item2": new Date()
            }],
            "table": "InboundsDeliveryNotesDetail"
        };
        return json;
    }

    private getJsonUpdate(inboundDeliveryNotesDetail: IInboundDeliveryNotesDetail) : any {
        const json = {
            "fieldsvalues": [{
                "Item1": "idInboundDeliveryNote",
                "Item2": inboundDeliveryNotesDetail.idInboundDeliveryNote
            }, {
                "Item1": "idInboundDetail",
                "Item2": inboundDeliveryNotesDetail.idInboundDetail
            }, {
                "Item1": "idGood",
                "Item2": inboundDeliveryNotesDetail.idGood
            }, {
                "Item1": "idListPallet",
                "Item2": inboundDeliveryNotesDetail.idListPallet
            }, {
                "Item1": "palletsAmount",
                "Item2": inboundDeliveryNotesDetail.palletsAmount
            }, {
                "Item1": "casesPerPallet",
                "Item2": inboundDeliveryNotesDetail.casesPerPallet
            }, {
                "Item1": "totalCases",
                "Item2": inboundDeliveryNotesDetail.totalCases
            }, {
                "Item1": "goodsPerCase",
                "Item2": inboundDeliveryNotesDetail.goodsPerCase
            }, {
                "Item1": "totalGoods",
                "Item2": inboundDeliveryNotesDetail.totalGoods
            }, {
                "Item1": "Location",
                "Item2": inboundDeliveryNotesDetail.location
            }, {
                "Item1": "weight",
                "Item2": inboundDeliveryNotesDetail.weight
            }, {
                "Item1": "bestBeforeDate",
                "Item2": inboundDeliveryNotesDetail.bestBeforeDate
            }, {
                "Item1": "ModifiedBy",
                "Item2": this.idUser
            }, {
                "Item1": "ModifiedDate",
                "Item2": new Date()
            }],
            "table": "InboundsDeliveryNotesDetail",
            "keyvalue": inboundDeliveryNotesDetail.id
        };
        return json;
    }

    private getJsonReadById(id: string) : any {
        const json = {
            "fields": [{
                "Item1": "InboundsDeliveryNotesDetail",
                "Item2": "id"
            }, {
                "Item1": "InboundsDeliveryNotesDetail",
                "Item2": "idInboundDeliveryNote"
            }, {
                "Item1": "InboundsDeliveryNotesDetail",
                "Item2": "idInboundDetail"
            }, {
                "Item1": "InboundsDeliveryNotesDetail",
                "Item2": "idGood"
            }, {
                "Item1": "",
                "Item2": "(select Name from Goods where id = InboundsDeliveryNotesDetail.IdGood) as goodName"
            }, {
                "Item1": "InboundsDeliveryNotesDetail",
                "Item2": "idListPallet"
            }, {
                "Item1": "",
                "Item2": "(select Name from ListPalletTypes where id = InboundsDeliveryNotesDetail.idListPallet) as palletName"
            }, {
                "Item1": "InboundsDeliveryNotesDetail",
                "Item2": "palletsAmount"
            }, {
                "Item1": "InboundsDeliveryNotesDetail",
                "Item2": "casesPerPallet"
            }, {
                "Item1": "InboundsDeliveryNotesDetail",
                "Item2": "totalCases"
            }, {
                "Item1": "",
                "Item2": "ISNULL((SELECT SUM(CasesPerPallet) FROM InboundsNoticeOfLossDetail WHERE IdInboundDeliveryNoteDetail = InboundsDeliveryNotesDetail.Id), 0) AS CasesLoss"
            }, {
                "Item1": "InboundsDeliveryNotesDetail",
                "Item2": "goodsPerCase"
            }, {
                "Item1": "InboundsDeliveryNotesDetail",
                "Item2": "totalGoods"
            }, {
                "Item1": "InboundsDeliveryNotesDetail",
                "Item2": "location"
            }, {
                "Item1": "InboundsDeliveryNotesDetail",
                "Item2": "weight"
            }, {
                "Item1": "InboundsDeliveryNotesDetail",
                "Item2": "bestBeforeDate"
            }, {
                "Item1": "InboundsDetail",
                "Item2": "language"
            }],
            "tables": [{
                "Item1": "InboundsDeliveryNotesDetail"
            }, {
                "Item1": "InboundsDetail"
            }],
            "joins": [{
                "Item1": "InboundsDeliveryNotesDetail",
                "Item2": "IdInboundDetail",
                "Item3": "InboundsDetail",
                "Item4": "Id"
            }],
            "conditions": [{
                "Item1": "InboundsDeliveryNotesDetail",
                "Item2": "Deleted",
                "Item3": "=",
                "Item4": "0",
                "Item5": "AND"
            }, {
                "Item1": "InboundsDeliveryNotesDetail",
                "Item2": "id",
                "Item3": "=",
                "Item4": id
            }]
        };
        return json;
    }

    private getJsonReadByIdInboundDeliveryNote(idInboundDeliveryNote: string) : any {
        const json = {
            "fields": [{
                "Item1": "InboundsDeliveryNotesDetail",
                "Item2": "id"
            }, {
                "Item1": "InboundsDeliveryNotesDetail",
                "Item2": "idInboundDeliveryNote"
            }, {
                "Item1": "InboundsDeliveryNotesDetail",
                "Item2": "idInboundDetail"
            }, {
                "Item1": "InboundsDeliveryNotesDetail",
                "Item2": "idGood"
            }, {
                "Item1": "",
                "Item2": "(select Name from Goods where id = InboundsDeliveryNotesDetail.IdGood) as goodName"
            }, {
                "Item1": "InboundsDeliveryNotesDetail",
                "Item2": "idListPallet"
            }, {
                "Item1": "",
                "Item2": "(select Name from ListPalletTypes where id = InboundsDeliveryNotesDetail.idListPallet) as palletName"
            }, {
                "Item1": "InboundsDeliveryNotesDetail",
                "Item2": "palletsAmount"
            }, {
                "Item1": "InboundsDeliveryNotesDetail",
                "Item2": "casesPerPallet"
            }, {
                "Item1": "InboundsDeliveryNotesDetail",
                "Item2": "totalCases"
            }, {
                "Item1": "",
                "Item2": "ISNULL((SELECT SUM(CasesPerPallet) FROM InboundsNoticeOfLossDetail WHERE IdInboundDeliveryNoteDetail = InboundsDeliveryNotesDetail.Id), 0) AS CasesLoss"
            }, {
                "Item1": "InboundsDeliveryNotesDetail",
                "Item2": "goodsPerCase"
            }, {
                "Item1": "InboundsDeliveryNotesDetail",
                "Item2": "totalGoods"
            }, {
                "Item1": "InboundsDeliveryNotesDetail",
                "Item2": "location"
            }, {
                "Item1": "InboundsDeliveryNotesDetail",
                "Item2": "weight"
            }, {
                "Item1": "InboundsDeliveryNotesDetail",
                "Item2": "bestBeforeDate"
            }, {
                "Item1": "InboundsDetail",
                "Item2": "language"
            }],
            "tables": [{
                "Item1": "InboundsDeliveryNotesDetail"
            }, {
                "Item1": "InboundsDetail"
            }],
            "joins": [{
                "Item1": "InboundsDeliveryNotesDetail",
                "Item2": "IdInboundDetail",
                "Item3": "InboundsDetail",
                "Item4": "Id"
            }],
            "conditions": [{
                "Item1": "InboundsDeliveryNotesDetail",
                "Item2": "Deleted",
                "Item3": "=",
                "Item4": "0",
                "Item5": "AND"
            }, {
                "Item1": "InboundsDeliveryNotesDetail",
                "Item2": "IdInboundDeliveryNote",
                "Item3": "=",
                "Item4": idInboundDeliveryNote
            }]
        };
        return json;
    }
}
